import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactRelationshipsService, ContactsService } from '../../../../core/lists';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import { currentUser } from '../../../../core/auth';
import { AppState } from '../../../../core/reducers';
import { CommunicationsService } from '../../../../core/timeline/_services';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';

@Component({
  selector: 'kt-send-message',
  templateUrl: 'send-message.dialog.component.html',
})
export class SendMessageDialogComponent implements OnInit {
  sendMessageForm: FormGroup;
  isFromTemplate = false;
  entityList: any;
  entityTypeBS = new BehaviorSubject('');
  sendToEntityBS = new BehaviorSubject('');
  subscription = new Subscription();
  entitySearchFields = [];
  toEntitySearchFields = [];
  entityAutocompleteCall;
  toEntityAutocompleteCall;
  facilityID: any;
  selectedEntity;
  selectedToEntity: any;
  senderName: string;
  receiver_type: string;
  receivers;
  toEntities: [];
  entities: [];
  hasFormErrors: boolean;
  whiteSpace;
  whiteSpaceBody;
  textLength = 0;
  apps = [];
  @ViewChild('entityAutocomplete') entityAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('toEntityAutocomplete') toEntityAutocomplete: GeneralAutocompleteComponent;
  editorOptions = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'], // remove formatting button
    ],
  };
  editorStyle = {
    height: '200px',
    backgroundColor: '#f5f5f5',
  };
  formatNewEntityFn(entity: any) {
    return entity;
  }
  ngOnInit() {
    this.subscription.add(
      this.entityTypeBS.subscribe((type) => {
        this.entitySearchFields = this.stringUtils.getEntitySearchFields(type);
        switch (type) {
          case 'CONTACT':
            this.entityAutocompleteCall = this.contactsService.searchContactByFieldAndApp.bind(
              this.contactsService,
              this.sendMessageForm.controls?.received?.value,
            );
            break;
          case 'FACILITY_CONTACT':
            this.entityAutocompleteCall = this.contactRelationshipsService.searchEntityByField.bind(
              this.contactRelationshipsService,
              'FACILITY',
            );
            break;
          case 'PATIENT_CONTACT':
            this.entityAutocompleteCall = this.contactRelationshipsService.searchEntityByField.bind(
              this.contactRelationshipsService,
              'patient',
            );
            break;
        }
      }),
    );
    this.subscription.add(
      this.sendToEntityBS.subscribe((typee) => {
        this.toEntitySearchFields = this.stringUtils.getEntitySearchFields(typee);
        switch (typee) {
          case 'Specific':
            this.toEntityAutocompleteCall = this.contactsService.getContactByRelatedIdAndApps.bind(
              this.contactsService,
              this.facilityID,
              this.sendMessageForm.controls?.received?.value,
            );
            break;
        }
      }),
    );
    this.createForm();
    this.sendMessageForm.controls.entityType.clearValidators();
    this.sendMessageForm.controls.toEntities.clearValidators();
    this.sendMessageForm.controls.entities.clearValidators();
    this.sendMessageForm.updateValueAndValidity();
  }
  constructor(
    public dialogRef: MatDialogRef<SendMessageDialogComponent>,
    public dialog: MatDialog,
    private sendMessageFB: FormBuilder,
    private contactsService: ContactsService,
    public stringUtils: StringUtilsService,
    private contactRelationshipsService: ContactRelationshipsService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private store: Store<AppState>,
    private communicationsService: CommunicationsService,
    private layoutUtilsService: LayoutUtilsService,
  ) {
    this.communicationsService.getApps().subscribe((res1) => {
      this.apps = res1;
    });
    this.store
      .pipe(select(currentUser))
      .subscribe((res) => (this.senderName = res && res.fullName ? res.fullName : ''));
  }
  setValidators() {
    this.sendMessageForm.get('entities')?.setValue(this.entityList);
    this.sendMessageForm.get('toEntities')?.setValue(this.entityList);
    this.sendMessageForm.get('sendToEntity')?.setValue(this.entityList);
    if (this.isFromTemplate) {
      this.sendMessageForm.controls.entityType.setValidators(Validators.required);
      this.sendMessageForm.controls.entityType.updateValueAndValidity();
    } else {
      this.sendMessageForm.controls.entityType.clearValidators();
      this.sendMessageForm.controls.entityType.updateValueAndValidity();
    }
  }
  onEntityChange(val) {
    this.sendMessageForm.controls.entities.setValue(val);
    this.sendMessageForm.controls.entities.updateValueAndValidity();
    this.facilityID = val.map((item) => {
      return item.id;
    });
  }
  onToEntityChange(val) {
    this.sendMessageForm.controls.toEntities.setValue(val);
    this.sendMessageForm.controls.toEntities.updateValueAndValidity();
  }
  change(val) {
    this.sendMessageForm.controls.toEntities.clearValidators();
    this.sendMessageForm.controls.toEntities.updateValueAndValidity();
    this.selectedEntity = val;
    this.entityTypeBS.next(this.sendMessageForm?.get('entityType')?.value);
    this.entityList = [];
    this.sendMessageForm.get('entityType')?.setValue(val);
    this.sendMessageForm.get('entities')?.setValue(null);
    this.sendMessageForm.get('toEntities')?.setValue(this.entityList);
    this.sendMessageForm.get('sendToEntity')?.setValue(this.entityList);
    switch (val) {
      case 'CONTACT':
        this.receiver_type = 'SPECIFIC';
        this.entityAutocompleteCall = this.contactsService.searchContactByFieldAndApp.bind(
          this.contactsService,
          this.sendMessageForm.controls?.received?.value,
        );
        this.sendMessageForm.controls.sendToEntity.clearValidators();
        this.sendMessageForm.controls.sendToEntity.updateValueAndValidity();
        break;
      case 'MOBILE_CONTACT':
        this.receiver_type = val;
        this.sendMessageForm.controls.sendToEntity.clearValidators();
        this.sendMessageForm.controls.sendToEntity.updateValueAndValidity();
        this.sendMessageForm.controls.entities.clearValidators();
        this.sendMessageForm.controls.entities.updateValueAndValidity();
        break;
      case 'FACILITY_CONTACT':
        // tslint:disable-next-line:max-line-length
        this.entityAutocompleteCall = this.contactRelationshipsService.searchEntityByField.bind(
          this.contactRelationshipsService,
          'FACILITY',
        );
        this.sendMessageForm.controls.sendToEntity.setValidators(Validators.required);
        this.sendMessageForm.controls.sendToEntity.updateValueAndValidity();
        break;
      case 'PATIENT_CONTACT':
        // tslint:disable-next-line:max-line-length
        this.entityAutocompleteCall = this.contactRelationshipsService.searchEntityByField.bind(
          this.contactRelationshipsService,
          'patient',
        );
        this.sendMessageForm.controls.sendToEntity.setValidators(Validators.required);
        this.sendMessageForm.controls.sendToEntity.updateValueAndValidity();
        break;
    }
  }
  onChange(val) {
    this.selectedToEntity = val;
    if (val === 'Specific') {
      this.receiver_type = 'SPECIFIC';
      this.sendMessageForm.controls.toEntities.setValidators(Validators.required);
      this.sendMessageForm.controls.toEntities.updateValueAndValidity();
    } else {
      this.receiver_type = this.selectedEntity;
      this.sendMessageForm.controls.toEntities.clearValidators();
      this.sendMessageForm.controls.toEntities.updateValueAndValidity();
    }
    this.sendToEntityBS.next(val);
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    this.entityList.push(event.option.value);
  }
  selectedTo(event: MatAutocompleteSelectedEvent): void {
    this.entityList.push(event.option.value);
  }
  submit() {
    const controls = this.sendMessageForm.controls;
    let notificationsRequest;
    let alertsRequest;
    if (controls.subject.value?.trim().length === 0) {
      this.whiteSpace = true;
      controls.subject.setErrors({ incorrect: true });
    } else if (controls.subject.value?.trim().length > 0) {
      controls.subject.setErrors(null);
      this.whiteSpace = false;
    }
    if (controls.body.value?.trim().length === 0) {
      this.whiteSpaceBody = true;
      controls.body.setErrors({ incorrect: true });
      this.sendMessageForm.updateValueAndValidity();
    } else if (controls.subject.value?.trim().length > 0) {
      controls.subject.setErrors(null);
      this.whiteSpace = false;
      this.sendMessageForm.updateValueAndValidity();
    }
    if (
      this.isFromTemplate &&
      (this.selectedEntity === 'CONTACT' ||
        this.selectedEntity === 'FACILITY_CONTACT' ||
        this.selectedEntity === 'PATIENT_CONTACT')
    ) {
      this.entityAutocomplete.updateValueAndValidity();
    }
    if (this.isFromTemplate && this.selectedToEntity === 'Specific') {
      this.toEntityAutocomplete.updateValueAndValidity();
    }
    this.hasFormErrors = false;
    if (this.sendMessageForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (!this.isFromTemplate) {
      notificationsRequest = {
        communication_type: 'NOTIFICATION',
        body: {
          subject: controls.subject.value,
          body: controls.body.value,
          applications: controls.received.value,
          sender_name: this.senderName,
        },
      };
    } else {
      const value =
        this.receiver_type === 'SPECIFIC' && this.selectedEntity === 'CONTACT'
          ? controls.entities.value
          : this.receiver_type === 'SPECIFIC' &&
            (this.selectedEntity === 'FACILITY_CONTACT' ||
              this.selectedEntity === 'PATIENT_CONTACT')
          ? controls.toEntities.value
          : [];
      const newObj = value.map((val) => {
        return {
          id: val.id,
          email: val.email,
          type: 'CONTACT',
          name: val.first_name + ' ' + val.last_name,
        };
      });
      this.entities = newObj;
      // tslint:disable-next-line:max-line-length
      const toEntityValue =
        this.receiver_type === 'PATIENT_CONTACT' || this.receiver_type === 'FACILITY_CONTACT'
          ? controls.entities.value
          : [];
      const newToEntity = toEntityValue.map((val) => {
        return {
          id: val.id,
          email: val.email,
          type: 'ENTITY',
          name: val.entity_type === 'PATIENT' ? val.first_name + ' ' + val.last_name : val.name,
        };
      });
      this.toEntities = newToEntity;
      // this.sendMessageForm.get('entities').setValue(this.entities);
      alertsRequest = {
        communication_type: 'ALERT',
        receiver_type: this.receiver_type,
        body: {
          subject: controls.subject.value,
          body: controls.body.value,
          sender_name: this.senderName,
          receivers: this.entities,
          applications: controls.received.value,
          // tslint:disable-next-line:max-line-length
          related_to_list: this.toEntities,
        },
      };
    }
    !this.isFromTemplate
      ? this.communicationsService.sendEmailFax(notificationsRequest).subscribe((res) => {
          if (res.data) {
            // tslint:disable-next-line:max-line-length
            this.layoutUtilsService.showActionNotification(
              this.translate.instant('EMAIL_FAX.SUCCESS'),
              MessageType.Update,
              3000,
              false,
              false,
            );
            this.dialogRef.close();
          }
        })
      : this.communicationsService.sendNotification(alertsRequest).subscribe((res) => {
          if (res.data) {
            // tslint:disable-next-line:max-line-length
            this.layoutUtilsService.showActionNotification(
              this.translate.instant('EMAIL_FAX.SUCCESS'),
              MessageType.Update,
              3000,
              false,
              false,
            );
            this.dialogRef.close();
          }
        });
  }
  createForm() {
    this.sendMessageForm = this.sendMessageFB.group({
      entityType: ['', Validators.required],
      related_to: [[]],
      subject: [null, Validators.required],
      body: [null, Validators.compose([Validators.required])],
      entities: ['', Validators.required],
      toEntities: ['', Validators.required],
      sendToEntity: [''],
      received: [null, Validators.required],
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.sendMessageForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  countTextLength(textWithStyle: string): number {
    const tempElement = this.renderer.createElement('div');
    this.renderer.setProperty(tempElement, 'innerHTML', textWithStyle);
    const visibleText = tempElement.textContent || '';
    this.textLength = visibleText.length;
    return this.textLength;
  }
  refreshContactList() {
    this.entityAutocompleteCall = this.contactsService.searchContactByFieldAndApp.bind(
      this.contactsService,
      this.sendMessageForm.controls?.received?.value,
    );
    this.toEntityAutocompleteCall = this.contactsService.getContactByRelatedIdAndApps.bind(
      this.contactsService,
      this.facilityID,
      this.sendMessageForm.controls?.received?.value,
    );
    this.entityList = [];
    this.sendMessageForm.get('entities')?.setValue(null);
    this.sendMessageForm.get('toEntities')?.setValue(this.entityList);
  }
}
